import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, AppRole } from '@/contexts/AuthContext';
import { Skeleton } from '@/components/ui/skeleton';
import AcessoNegado from '@/pages/AcessoNegado';
import ErroPermissoes from '@/pages/iam/ErroPermissoes';
import { resolverHome } from '@/utils/homeRoute';


interface ProtectedRouteProps {
  requiredRoles?: AppRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRoles }) => {
  const { user, loading, hasAnyRole, roles, rolesLoading, rolesError, podeAcessar } = useAuth();
  const location = useLocation();
  const isOnOnboarding = location.pathname === '/onboarding' || location.pathname === '/regularizacao-docente';

  if (loading || rolesLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="space-y-4 w-64">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Redirect to onboarding if blocked (any role)
  if (podeAcessar === false && !isOnOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  // Se está no onboarding mas não precisa, redireciona para a home da role
  if (isOnOnboarding && podeAcessar === true) {
    return <Navigate to={resolverHome(roles)} replace />;
  }


  if (requiredRoles && requiredRoles.length > 0) {
    if (rolesError) {
      return <ErroPermissoes />;
    }

    if (roles.length === 0 && !rolesLoading) {
      // Se não carregou roles e não está carregando, mas é necessário role, acesso negado
      return <AcessoNegado rolesNecessarias={requiredRoles} rolesAtuais={roles} />;
    }

    const hasAccess = hasAnyRole(requiredRoles);

    if (!hasAccess) {
      return <AcessoNegado rolesNecessarias={requiredRoles} rolesAtuais={roles} />;
    }
  }

  return <Outlet />;
};
